import { render, staticRenderFns } from "./deleteStaffPrivilege.vue?vue&type=template&id=2d6ea128"
import script from "./deleteStaffPrivilege.vue?vue&type=script&lang=js"
export * from "./deleteStaffPrivilege.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports